<template>
    <div class="pro_box" v-cloak>
      <div class="tbs_box">
            <div 
                class="tab_item" 
                :class="active==item.id?'cactive':''"
                @click="tabswitch(item)"
                v-for="(item,index) of tab" :key="index">
                {{ item.title }}
            </div>
        </div>
        <div class="content_one_box" v-if="active==1">
            <div class="child_content">
                <div class="item_box" v-for="(item,index) of humanlist" :key="index">
                    <img class="img_box" :src="item.resource" alt="">
                    <div class="font_box">
                        <div class="font_title">{{ item.title }}</div>
                        <div  class="html_box" v-html="item.content"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default{
    data(){
        return{
            textarea:null,
            active:null,
            tab:[
                {id:1,title:'HR数字化转型'},
            ],
            humanlist:[],
          
            text:null,
        }
    },
    created(){
        
        if(this.$route.query.type){
            this.active=Number(this.$route.query.type)
        }else{
            this.active=this.tab[0].id;
        }
        this.axioslist()
    },
    methods:{
        axioslist(){
            this.$webhttp.get('v1/web/number').then((res)=>{
                if(res.code==200){
                    res.data.forEach((item,index,array)=>{
                        item.content=item.content.replace(/\n/g,'<br/>')        
                    })
                    this.humanlist=res.data
                }else{  
                    this.$message.error(res.message)
                }
            })
        },
        tabswitch(item){
            this.active=item.id
        }
    },
}
</script>
<style lang="less" scoped>

.pro_box{
    width: 100%;
    padding: 0px 160px;
    box-sizing: border-box;
    display: flex;
    .content_two_box{
        height: 100%;
        width: 80%;
        box-sizing: border-box;
        border-right: 1px solid brown;
        border-left: 1px solid brown;
    }
    .content_one_box{
        height: 100%;
        box-sizing: border-box;
        padding-top: 40px;
        padding-left: 92px;
        .child_content{
            display: flex;
            justify-content: space-around;
            box-sizing: border-box;
            margin-bottom: 120px;
            min-height: 500px;
             .item_box:hover{
                .font_box{
                    border-left: 1px solid #3380FF;
                    border-right: 1px solid #3380FF;
                    border-bottom: 1px solid #3380FF;
                    .html_box{
                        color: #101010;
                    }
                }
              
                   
            }
            .item_box{
                width: 420px;
                min-height: 500px;
                background: #FFFFFF;
                box-sizing: border-box;
                margin-right: 24px;
                position: relative;
                cursor: pointer;
                .img_box{
                    width:420px;
                    height: 240px;
                    box-sizing: border-box;
                    vertical-align:bottom;
                }
                .font_box{
                    width: 420px;
                    min-height: 260px;
                    box-sizing: border-box;
                    border-right: 1px solid  #D5D5D5;
                    border-left: 1px solid  #D5D5D5;
                    border-bottom: 1px solid  #D5D5D5;
                    padding: 17px 32px 19px 24px;
                    .html_box{
                        color: #606060;
                    }
                    .font_title{
                        font-weight: 400;
                        font-size: 20px;
                        color: #101010;
                        line-height: 30px;
                        margin-bottom: 22px;
                    }
                }
            }
        }
        

    }
    .tbs_box{
        height: 100%;
        box-sizing: border-box;
        padding-top: 40px;
        .tab_item:hover{
            background: #027DFC;
            font-weight: 400;
            font-size: 14px;
            color: #FFFFFF;
            line-height: 40px;

        }
        .cactive{
            background: #027DFC !important;
            color: #FFFFFF !important;
        }
        .tab_item{
            border: 1px solid #ECECEC;
            background: #FFFFFF;
            height: 40px;
            width: 200px;
            text-align: center;
            line-height: 40px;
            box-sizing: border-box;
            cursor: pointer;
            font-weight: 400;
            font-size: 14px;
            color: #606060;
            line-height: 40px;
        }
    }
}
</style>